import styled from "styled-components";
import { modeStyle, themeStyle } from "utils/styles";

const Card = styled.div`
  display: inline-block;
  background: ${modeStyle("white", "#353535")};
  border: 1px solid ${modeStyle("#dcdcdc", "#5D5D5D")};
  color: ${themeStyle("colors.primaryText")};
  box-shadow: 1px 3px 5px rgba(0, 0, 0, 0.07);
  border-radius: 4px;
`;

export default Card;
